import Link from "next/link";

import { routes } from "src/shared/routes";

import type { TTeamConfig } from "src/shared/types/teamConfig.types";
import type { TRegistrationCardData } from "src/shared/types/globalStotre.types";

export const REGISTRATION_CARDS: TRegistrationCardData[] = [
  {
    title: "Purchase Iowa State Upgrades",
    description:
      "Enhance your gameday experience by upgrading your Iowa State tickets here. To purchase your upgrade, please log in with the same email address you use to manage your tickets. Upgrade purchases are non-refundable. Upgrades purchased in connection with this program are for personal use only and may not be transferred or resold. You must have a valid game ticket to today's game in order to participate in this exclusive opportunity. Offer valid for select seating areas, subject to availability.",
    buttonLabel: "View Available Upgrades",
    authRedirectPage: routes.home,
  },
];

export const FAQS: TTeamConfig["LANGUAGES"]["FAQS"] = [
  {
    question: "Why don't I see seat upgrades available for purchase?",
    answer:
      "You must have a valid game ticket to today's game in order to participate in this exclusive opportunity. Offer valid for select seating areas.",
  },
  {
    question: "Will there be seat upgrades available for every game?",
    answer:
      "Upgrades are subject to availability. Please check prior to your game to view available upgrades.",
  },
  {
    question: "Can these tickets be transferred to a friend?",
    answer:
      "Upgrades purchased in connection with this program are for personal use only and may not be transferred or resold.",
  },
  {
    question: "Can my seats be changed?",
    answer:
      "After successful purchase, your tickets cannot be changed. Upgrade purchases are non-refundable.",
  },
];

export const TERMS_AND_CONDITION = () => (
  <>
    By purchasing you agree to receive SMS alerts regarding ticket delivery and
    agree to the{" "}
    <Link target="_blank" href="https://www.attend.tech/terms-of-use">
      Terms of Use
    </Link>{" "}
    and{" "}
    <Link target="_blank" href="https://www.attend.tech/privacy-policy">
      Privacy Policy
    </Link>
    .
  </>
);
